import React from 'react';

import { Alert } from 'antd';

const Atention = () => {
  return (
    <Alert
      type='info'
      showIcon
      message='Atenção'
      description='Em páginas de vendas que são abertas a partir de APPs de redes sociais, links com o atributo HTML target="blank" podem não funcionar. Recomendamos que o atributo não seja utilizado.'
    />
  );
};

export default Atention;
